<template>
  <v-dialog v-model="isOpen" width="700" persistent>
    <v-card>
      <v-card-title>
        <span class="table-card-title">Produtos com ofertas no ERP</span>
        <p class="texto-corrido mt-2 mb-0">Os seguintes produtos já possuem ofertas para o mesmo período no ERP:</p>
      </v-card-title>

      <v-card-text>
        <v-data-table
          fixed-header
          height="390px"
          class="pb-3"
          :headers="headers"
          :items="items"
          :items-per-page="10"
          :footer-props="{ itemsPerPageOptions: [10] }"
        >
          <template v-slot:item="{ item }">
            <tr>
              <td>
                <div class="img-container d-flex align-center justify-center">
                  <img v-if="item.image_url" :src="item.image_url" alt="" width="100%" />
                  <mf-icon v-else>image_not_supported</mf-icon>
                </div>
              </td>

              <td>
                {{ item.sku }}
              </td>

              <td>
                <span>{{ item.name }}</span>
              </td>
            </tr>
          </template>
        </v-data-table>

        <mf-action-buttons
          :primary-button="{
            text: 'Fechar',
            action: () => (isOpen = false),
            isVisible: true,
          }"
        />
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
export default {
  name: 'UnavailableProductsDialog',
  components: {},
  props: {
    value: {
      type: Boolean,
      default: false,
    },
    products: {
      type: Array,
      default: () => [],
    },
    unavailableProducts: {
      type: Array,
      default: () => [],
    },
  },
  computed: {
    isOpen: {
      get() {
        return this.value
      },
      set(value) {
        this.$emit('input', value)
      },
    },
    headers() {
      return [
        {
          text: '',
          value: 'image',
          width: '10%',
          sortable: false,
        },
        {
          text: 'SKU',
          value: 'sku',
          width: '20%',
          sortable: false,
        },
        {
          text: 'Nome',
          value: 'name',
          width: '70%',
          sortable: false,
        },
      ]
    },
    items() {
      return this.products.filter((product) => this.unavailableProducts.includes(product.sku))
    },
  },
}
</script>
